import ArreasOption from "./components/ArrearsOption/ArrearsOption"
import RecurrencyOption from "./components/RecurrencyOption/RecurrencyOption"
import './styles.css'

const NewEditTemplateCollectionBodyOptions = () => {
    return (
        <div className="new-edit-template-collection-body-options">
            <RecurrencyOption />
            <ArreasOption />
        </div>
    )
}

export default NewEditTemplateCollectionBodyOptions
